<template>
  <div class="video_all_z" ref="father_file">
    <div class="video_left_z" >
       <div class="whole"  v-if="file.info.type=='pdf'">
           <div style="margin-bottom: 15px; text-align: right">
             <el-button type="primary" size="small" @click="scaleD">
                放大
              </el-button>
              <el-button type="primary" size="small" @click="scaleX">
                缩小
             </el-button>
             <el-button type="primary" size="small" @click.stop="pdf_previousPage">
                上一页
              </el-button>
              <el-button type="primary" size="small" @click.stop="pdf_nextPage">
              下一页
             </el-button>
             <span>当前第{{file.pdfPage}}页 / 共{{file.pageCount}}页</span>
           </div>
           <div style="display: flex;justify-content: center;">
            <pdf style="overflow-y: auto;"
            ref="wrapper"
              :src="file.url"
              :page="file.pdfPage"
              @num-pages="file.pageCount = $event"
              @page-loaded="file.pdfPage = $event"
           ></pdf>
           </div>
        </div>
        <div class="whole" v-if="file.info.type=='html'" >
           <iframe  :src="file.url"  frameborder="0" :height="height"  style="width: 100%;"></iframe>
        </div>
      </div>
      <div class="resize_z" title="收缩侧边栏"></div>
      <div class="video_right_z">
        <video ref="videoPlayer" class="video-js video vjs-big-play-centered" width="100%"  controlslist="nodownload noremoteplayback" oncontextmenu = "return false">
        </video>
      </div>
    </div>


  </div>
</template>

<script>
  import pdf from 'vue-pdf'
   export default {
      data(){
        return{
           num:this.$route.query.num,
           file:{
             scale:100,
             info:[],
             url:'',
             pdfPage : 1,
             pageCount: 0,
           },
           player: null,
           videoOptions: {
             // lang: 'zh-CN',
             autoplay: false,//自动播放
             controls: true,//用户可以与之交互的控件
             // loop:false,//视频一结束就重新开始
             muted:false,//默认情况下将使所有音频静音
             // aspectRatio:"16:9",//显示比率
             // preload:false,//预加载
             notSupportedMessage: '此视频暂无法播放，请稍后再试',
             playbackRates: [0.5, 1, 1.5,2,3],//倍数
             errorDisplay: false,
             fluid: true,
             fullscreen:{
                 options: {navigationUI: 'hide'}
             },
             sources:[{
               src: "",
               type: ""
             }],
           },
        }
      },
      components: {
        pdf
      },
       mounted: function () {
         this.get_info()
         this.change_height()
         this.dragControllerDiv()
       },
       methods:{
         scaleD() {
           this.file.scale += 5;
           this.$refs.wrapper.$el.style.width = parseInt(this.file.scale) + "%";
         },
         //缩小
         scaleX() {
           this.file.scale += -5;
           this.$refs.wrapper.$el.style.width = parseInt(this.file.scale) + "%";
         },
         get_info(){
           let _this=this
           _this.axios.get("/v2/user_resource/get_file_info", {
              params: { file: _this.num,type:'train' },
            })
            .then(function (res) {
              if (res.status == "200") {
                if (res.data.code == "1") {
                  _this.file.info=res.data.data
                  if(res.data.data.type=='pdf'){
                    _this.file.url=pdf.createLoadingTask('/v2/user_resource/file_watch?key='+localStorage.authorization)
                  }else{
                    _this.file.url='/v2/user_resource/file_watch?key='+localStorage.authorization
                  }
                  if(res.data.data.video){
                    _this.videoOptions.sources[0].type=res.data.data.video.type
                    _this.videoOptions.sources[0].src=res.data.data.video.src
                    if(_this.player){
                      _this.player.src({type:_this.videoOptions.sources[0].type, src:_this.videoOptions.sources[0].src})
                      _this.player.load()
                    }else{
                      _this.$nextTick(()=>{
                        _this.player = _this.$video(_this.$refs.videoPlayer, _this.videoOptions, function onPlayerReady() {

                        })
                      })
                    }
                  }
                } else {
                  _this.$message.error("服务器内部错误");
                }
              } else {
                _this.$message.error("服务器内部错误");
              }
            });
         },
         change_height(){
           let _this=this
           _this.height=window.innerHeight + 'px'
         },
         dragControllerDiv: function () {
           var resize = document.getElementsByClassName('resize_z');
           var left = document.getElementsByClassName('video_left_z');
           var mid = document.getElementsByClassName('video_right_z');
           var box = document.getElementsByClassName('video_all_z');
           for (let i = 0; i < resize.length; i++) {
               // 鼠标按下事件
             resize[i].onmousedown = function (e) {

                 var startX = e.clientX;
                 resize[i].left = resize[i].offsetLeft;
                 // 鼠标拖动事件
                 document.onmousemove = function (e) {
                     var endX = e.clientX;
                     var moveLen = resize[i].left + (endX - startX); // （endx-startx）=移动的距离。resize[i].left+移动的距离=左边区域最后的宽度
                     var maxT = box[i].clientWidth - resize[i].offsetWidth; // 容器宽度 - 左边区域的宽度 = 右边区域的宽度

                     if (moveLen < 5) moveLen = 5; // 左边区域的最小宽度为32px
                     if (moveLen > maxT - 5) moveLen = maxT - 5; //右边区域最小宽度为150px

                     resize[i].style.left = moveLen; // 设置左侧区域的宽度


                     for (let j = 0; j < left.length; j++) {
                         left[j].style.width = moveLen + 'px';
                         mid[j].style.width = (box[i].clientWidth - moveLen - 15) + 'px';
                     }
                 };
                 // 鼠标松开事件
                 document.onmouseup = function (evt) {
                     //颜色恢复
                     document.onmousemove = null;
                     document.onmouseup = null;
                     resize[i].releaseCapture && resize[i].releaseCapture(); //当你不在需要继续获得鼠标消息就要应该调用ReleaseCapture()释放掉
                 };
                 resize[i].setCapture && resize[i].setCapture(); //该函数在属于当前线程的指定窗口里设置鼠标捕获
                 return false;
             };
           }
         },
         pdf_previousPage(){
           var p = this.file.pdfPage
           p = p>1?p-1:this.file.pageCount
           this.file.pdfPage = p
         },
         pdf_nextPage(){
           var p = this.file.pdfPage
           p = p<this.file.pageCount?p+1:1
           this.file.pdfPage = p
         },
       },
   }

</script>

<style >
  body{
    /* background-color: white; */
  }
  .video_all_z{
    width:100%;
    margin: 1% 0px;
    overflow: hidden;
  }
  .video_left_z{
    width: calc(62% - 10px); /*左侧初始化宽度*/
    float: left;
    height: calc(100% - 5rem);
  }
  .video_right_z{
    float: left;
    width: 32%;   /*右侧初始化宽度*/
    height:100%;
  }
  .resize_z {
      cursor: col-resize;
      float: left;
      position: relative;
      background-color: #d6d6d6;
      border-radius: 5px;
      margin-top: 25rem;
      width: 10px;
      height: 50px;
      background-size: cover;
      background-position: center;
      /*z-index: 99999;*/
      font-size: 32px;
      color: white;
  }
  /*拖拽区鼠标悬停样式*/
  .resize_z:hover {
      color: #444444;
  }
</style>



// WEBPACK FOOTER //
// src/view/index/Task/taskfile/Video.vue